module.exports = __webpack_public_path__ + "static/404-image-b9e00298924f2f2b92b7276ac9fa5fda.png";